define('all/player/uk-depositlimit-pendingcheck',['jquery', 'all/player/session', 'all/player/login', 'all/pretty-links'], function ($, session, dialog, prettyLinks) {
	'use strict';
	$(session).on('login', callbackAtLogin);

	if((location.pathname + location.hash) === prettyLinks.getLink('MyPages', 'MyAccount')){
		callbackAtLogin();
	}

	function callbackAtLogin() {
		$.getJSON('/pp?flow=GetPlayerDepositLimitToUpdate', {},
		function (data) {
			if (data.RESULT === 'OK') {
				var popupData = {
					heading: data.POPUP_HEADER,
					message: data.POPUP_BODY,
					buttonAgree: data.AGREE,
					buttonDecline: data.DECLINE,
					dailyBody: data.DAY_BODY,
					weeklyBody: data.WEEK_BODY,
					monthlyBody: data.MONTH_BODY,
					day: data.DAY,
					week: data.WEEK,
					month: data.MONTH
				};
				window.top.dialog.load('responsiblegaming/UKDepositLimitResGamingPopup', popupData, undefined, undefined);
			}
		});
	}

	function applyPendingDepositLimit(day, week, month){
		$.getJSON('/pp?flow=ApplyPendingPlayerDepositLimit', {
				PARAM_DAY_ID: day,
				PARAM_WEEK_ID: week,
				PARAM_MONTH_ID: month
			},
			function (data) {
				if (data.RESULT === 'OK') {
					window.top.dialog.load('responsiblegaming/UKDepositLimitResGamingResultSucces', {
						message: data.POPUP_BODY
					});
				} else{
					window.top.dialog.load('responsiblegaming/UKDepositLimitResGamingResultFail', {});
				}
			});
		window.top.dialog.close('UKDepositLimitResGamingPopup');
	}

	function discardPendingDepositLimit(day, week, month){
		$.getJSON('/pp?flow=DiscardPendingPlayerDepositLimit', {
				PARAM_DAY_ID: day,
				PARAM_WEEK_ID: week,
				PARAM_MONTH_ID: month
			},
			function (data) {
				window.top.dialog.close('UKDepositLimitResGamingPopup');
				if (data.RESULT === 'OK') {
					window.top.dialog.load('responsiblegaming/UKDepositLimitResGamingResultSucces', {
						message: data.POPUP_BODY
					});
				} else{
					window.top.dialog.load('responsiblegaming/UKDepositLimitResGamingResultFail', {});
				}
			});

	}
	window.ukdepositlimitpopup = {
		applyPendingDepositLimit: applyPendingDepositLimit,
		discardPendingDepositLimit: discardPendingDepositLimit
	};
	return window.ukdepositlimitpopup;

});

